export function initPrimaryLogo() {
	const primaryLogoContainer = document.getElementById("primary-logo-container");
	if (!primaryLogoContainer) return;

	const primaryLogoUrl = primaryLogoContainer.getAttribute("data-logo-url");
	const logoLink = primaryLogoContainer.getAttribute("data-logo-link");
	const logoWrapper = document.getElementById("itu-primary-logo");
	const targetImg = logoWrapper ? logoWrapper.querySelector("img") : null;

	if (!primaryLogoUrl) return;

	const applyLogoSize = (img) => {
		img.style.maxHeight = "48px";
		img.style.width = "auto";
		img.style.height = "auto";
	};

	if (logoLink) {
		const newLink = document.createElement("a");
		newLink.href = logoLink;
		const newImg = document.createElement("img");
		newImg.src = primaryLogoUrl;
		newImg.alt = "Primary Logo";
		applyLogoSize(newImg);
		newLink.appendChild(newImg);
		if (logoWrapper) {
			logoWrapper.replaceWith(newLink);
			newLink.id = "itu-primary-logo";
		}
	} else if (targetImg) {
		targetImg.src = primaryLogoUrl;
		applyLogoSize(targetImg);
	}
}
